import React from 'react';
import Anchor from "../../objects/Anchor";

const SocialMediaIcons = props => {

    return (
        props.social.map(item => {
            if (item.name === 'facebook') {
                return (
                    <Anchor key={item.url} path={item.url} anchorClass={'social-link'} target>
                        <img src='/images/icons-new/facebook-blue.svg' alt={'Facebook Icon'} className="social-image"/>
                    </Anchor>
                )
            }
            if (item.name === 'twitter') {
                return (
                    <Anchor key={item.url} path={item.url} anchorClass={'social-link'} target>
                        <img src='/images/icons-new/twitter-blue.svg' alt={'Twitter Icon'} className="social-image"/>
                    </Anchor>
                )
            }
            if (item.name === 'linkedin') {
                return (
                    <Anchor key={item.url} path={item.url} anchorClass={'social-link'} target>
                        <img src='/images/icons-new/linkedin-blue.svg' alt={'LinkedIn Icon'} className="social-image"/>
                    </Anchor>
                )
            }
            if (item.name === 'youtube') {
                return (
                    <Anchor key={item.url} path={item.url} anchorClass={'social-link'} target>
                        <img src='/images/icons-new/youtube-blue.svg' alt={'Youtube Icon'} className="social-image"/>
                    </Anchor>
                )
            }
        })
    )
};

export default SocialMediaIcons;


// WEBPACK FOOTER //
// src/client/components/dashboardNew/components/social/SocialMediaIcons.js